/** A blank participant cell is zero only after the caller has established a recorded game.
 * Missing fields are invalid, not an instruction to erase an existing score. */
export function normalizeScoreCell(value: number | string | null): number {
  if (value === null || (typeof value === 'string' && value.trim() === '')) return 0;
  if (typeof value === 'string' && !/^-?\d+$/.test(value.trim())) throw new Error('Enter a whole-number score.');
  const score = Number(value);
  if (!Number.isSafeInteger(score)) throw new Error('Enter a whole-number score.');
  return score;
}

/** Strip untouched raw rows before numeric coercion; explicit zero is never blank.
 * This is a request preprocessor, not a replacement for the route's structural validation. */
export function omitUntouchedScoreRows(input: unknown): unknown {
  if (!Array.isArray(input)) return input;
  const recorded = new Set<unknown>();
  for (const item of input) {
    if (!item || typeof item !== 'object') return input;
    const entry = item as Record<string, unknown>;
    const blank = entry.points === null || (typeof entry.points === 'string' && entry.points.trim() === '');
    if (!blank || entry.game) recorded.add(entry.gameNumber);
  }
  return input.filter(item => recorded.has((item as Record<string, unknown>).gameNumber));
}
